<template>
  <div id="survey_intro" class="health-check-survey-intro" v-on:click="start">
    <div v-html="hcData.instructions"></div>
  </div>
</template>

<script>
import store from "../store";

export default {
  store: store,
  name: "SurveyIntro",
  computed: {
    hcData() {
      return store.getters.hcData;
    }
  },
  methods: {
    start() {
      var VueScrollTo = require("vue-scrollto");

      VueScrollTo.scrollTo(
        document.querySelector(".questions-panel__inner"),
        500,
        {
          container: "#health_check__container"
        }
      );
    }
  }
};
</script>

<style lang="scss">
.health-check-survey-intro {
  padding: 64.5px 0 0;
  cursor: pointer;

  @media (max-width: 767px) {
    padding: 15.5px 0 0;
  }

  &:after {
    content: "";
    width: 34px;
    height: 73px;
    display: block;
    margin: 23px auto 0;
    background: {
      image: url("../../../assets/images/health-check-down-arrow.svg");
      size: contain;
      repeat: no-repeat;
    }

    @media (max-width: 767px) {
      height: 51px;
      width: 34px;
    }
  }
}
</style>
